import { CommerceService } from "@/services/commerce"

export const resolverCustomerPrice = {
  CustomerPrice: {
    async type(obj, args, context, info) {
      const { customerId } = obj
      if (customerId) return "CUSTOMER_SPECIFIC_PRICE"
      else return "CUSTOMER_GROUP_PRICE"
    },

    async price(obj, args, context, info) {
      const { customerId, customerGroup, sku } = obj

      const ctpApi = CommerceService.api()

      let price = null

      if (customerId) {
        const key = sku + "_" + customerId
        try {
          const res = await ctpApi.standalonePrices().withKey({ key }).get().execute()

          price = res.body.value.centAmount / 100
        } catch (e) {
          console.warn(e)
        }
      }

      if (!price && customerGroup) {
        const key = sku + "_" + customerGroup
        try {
          const res = await ctpApi.standalonePrices().withKey({ key }).get().execute()

          price = res.body.value.centAmount / 100
        } catch (e) {
          console.warn(e)
        }
      }
      if (!price) {
        const key = sku + "_customer-group-a"
        try {
          const res = await ctpApi.standalonePrices().withKey({ key }).get().execute()

          price = res.body.value.centAmount / 100
        } catch (e) {
          console.warn(e)
        }
      }

      return price
    },
  },
}
